import { useEffect } from 'react'
import { canBootstrapSectionResource } from './bootstrapPermissions'

type UseAdminAppBootstrapParams = {
  isAuthenticated: boolean
  requiresDeviceTrust: boolean
  isCustomerOnly?: boolean
  userCapabilities?: string[]
  loadSlides: () => Promise<void>
  loadPages: () => Promise<void>
  loadProfile: () => Promise<void>
  loadSessions: () => Promise<void>
}

export const useAdminAppBootstrap = ({
  isAuthenticated,
  requiresDeviceTrust,
  isCustomerOnly = false,
  userCapabilities = [],
  loadSlides,
  loadPages,
  loadProfile,
  loadSessions,
}: UseAdminAppBootstrapParams) => {
  const userCapabilitiesKey = userCapabilities.join('\0')

  useEffect(() => {
    void loadSlides()
  }, [loadSlides])

  useEffect(() => {
    if (!isAuthenticated) return

    if (requiresDeviceTrust) {
      void Promise.all([loadSessions(), loadProfile()])
      return
    }

    if (isCustomerOnly) {
      void Promise.all([loadProfile(), loadSessions()])
      return
    }

    const bootstrapTasks = [
      loadSlides(),
      loadProfile(),
    ]

    const resolvedUserCapabilities = userCapabilitiesKey ? userCapabilitiesKey.split('\0') : []
    if (canBootstrapSectionResource('pages', resolvedUserCapabilities)) {
      bootstrapTasks.push(loadPages())
    }

    void Promise.all(bootstrapTasks)
  }, [
    isAuthenticated,
    requiresDeviceTrust,
    isCustomerOnly,
    userCapabilitiesKey,
    loadPages,
    loadProfile,
    loadSessions,
    loadSlides,
  ])
}
